/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */
function setupFacebookPixel() {
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '530420187131784');
  fbq('track', 'PageView');

  document.body.insertAdjacentHTML('beforeend',
    '<img height="1" width="1" style="display:none;" src="https://www.facebook.com/tr?id=530420187131784&ev=PageView&noscript=1"/>')
}

function setupLinkedInInsight() {
  window._linkedin_data_partner_id = "67429";
  (function(){var s = document.getElementsByTagName("script")[0];
    var b = document.createElement("script");
    b.type = "text/javascript";b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);})();

  document.body.insertAdjacentHTML('beforeend',
  '<img height="1" width="1" style="display:none;" alt="" src="https://dc.ads.linkedin.com/collect/?pid=67429&fmt=gif" />')
}

export default function() {
  setupFacebookPixel()
  setupLinkedInInsight()
}



// WEBPACK FOOTER //
// ./src/service/pixelTracking.js